import { render } from "./DetailContentView.vue?vue&type=template&id=7957e2d9&scoped=true"
import script from "./DetailContentView.vue?vue&type=script&lang=js"
export * from "./DetailContentView.vue?vue&type=script&lang=js"

import "./DetailContentView.vue?vue&type=style&index=0&id=7957e2d9&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7957e2d9"]])

export default __exports__